import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import SideBarCategoryItem from "../components/home-page-logged-in/SideBarCategoryItem";
import SingleCategoryItem from "../components/home-page-logged-in/SingleCategoryItem";
import SearchResultItem from "../components/SearchResultItem";
import SideBarSimilarProfileItem from "../components/SideBarSimilarProfileItem";
import SimilarProfileItem from "../components/SimilarProfileItem";
import classes from "./SearchResults.module.css";
import educationIcon from "../components/images/education-icon.png";
import dataIcon from "../components/images/data-icon.png";
import techIcon from "../components/images/tech-icon.png";
import petIcon from "../components/images/pet-icon.png";
import religionIcon from "../components/images/religion-icon.png";
import fashionIcon from "../components/images/fashion-icon.png";

export default function SearchResults() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [similarProfiles, setSimilarProfiles] = useState({
    status: 200,
    data: [
      {
        name: "Guy Hawkins",
        image: "https://picsum.photos/id/63/500",
        description:
          "Anthropologist researcher lorem ipsum dolor site amte site lorem...",
        jobTitle: "anthropoogist researcher",
        username: "johnsmith1860",
        id: 2,
      },
      {
        name: "Amenda james",
        image: "https://picsum.photos/id/64/500",
        description:
          "Anthropologist researcher lorem ipsum dolor site amte site lorem...",
        jobTitle: "anthropoogist researcher",
        username: "johnsmith1860",
        id: 2,
      },
      {
        name: "Lia fariz",
        image: "https://picsum.photos/id/65/500",
        description:
          "Anthropologist researcher lorem ipsum dolor site amte site lorem...",
        jobTitle: "anthropoogist researcher",
        username: "johnsmith1860",
        id: 2,
      },
      {
        name: "James Sandar",
        image: "https://picsum.photos/id/91/500",
        description:
          "Anthropologist researcher lorem ipsum dolor site amte site lorem...",
        jobTitle: "anthropoogist researcher",
        username: "johnsmith1860",
        id: 2,
      },
      {
        name: "Amenda james",
        image: "https://picsum.photos/id/64/500",
        description:
          "Anthropologist researcher lorem ipsum dolor site amte site lorem...",
        jobTitle: "anthropoogist researcher",
        username: "johnsmith1860",
        id: 2,
      },
    ],
  });

  const [articles, setArticles] = useState({
    status: 200,
    articles: [
      {
        id: 123,
        title: "The Role of Cytokines in Cancer Immunotherapy",
        thumbnail_url: "https://picsum.photos/id/54/500",
        score: "100%",
        read_time: 2,
        author: "jenny willson",
        saved: true,
      },
      {
        id: 123,
        title: "The Role of Cytokines in Cancer Immunotherapy",
        thumbnail_url: "https://picsum.photos/id/55/500",
        score: "65%",
        read_time: 2,
        author: "jenny willson",
        saved: false,
      },
      {
        id: 123,
        title: "The Role of Cytokines in Cancer Immunotherapy",
        thumbnail_url: "https://picsum.photos/id/56/500",
        score: "65%",
        read_time: 2,
        author: "jenny willson",
        saved: false,
      },
      {
        id: 123,
        title: "The Role of Cytokines in Cancer Immunotherapy",
        thumbnail_url: "https://picsum.photos/id/57/500",
        score: "65%",
        read_time: 2,
        author: "jenny willson",
        saved: true,
      },
      {
        id: 123,
        title: "The Role of Cytokines in Cancer Immunotherapy",
        thumbnail_url: "https://picsum.photos/id/58/500",
        score: "65%",
        read_time: 2,
        author: "jenny willson",
        saved: true,
      },
      {
        id: 123,
        title: "The Role of Cytokines in Cancer Immunotherapy",
        thumbnail_url: "https://picsum.photos/id/59/500",
        score: "65%",
        read_time: 2,
        author: "jenny willson",
        saved: false,
      },
    ],
  });

  const [categoriesList, setCategoriesList] = useState([
    {
      title: "education",
      icon: educationIcon,
    },
    {
      title: "data",
      icon: dataIcon,
    },
    {
      title: "tech",
      icon: techIcon,
    },
    {
      title: "pets",
      icon: petIcon,
    },
    {
      title: "religion",
      icon: religionIcon,
    },
    {
      title: "fashion",
      icon: fashionIcon,
    },
  ]);

  return (
    <div className={`container customContainer ${classes.mainContainer}`}>
      <div className="row">
        <div className={`col-xxl-9 col-12 ${classes.leftContainer}`}>
          <div className={classes.searchResultsHeadingContainer}>
            <p className={classes.searchResultsHeading}>
              Search Results for <span>"{searchParams.get("q")}"</span>
            </p>
          </div>
          <div className={`row ${classes.articlesContainer}`}>
            {articles.articles.map((article, key) => (
              <SearchResultItem {...article} key={key} />
            ))}
          </div>
          <div
            className={`d-xxl-none d-block ${classes.mobileSearchProfileContainer}`}
          >
            <p className={classes.profileSearchResultsTitle}>
              Profile search resutls
            </p>
            <div className="row">
              {similarProfiles.data.map((profile, key) => (
                <SimilarProfileItem {...profile} key={key} />
              ))}
            </div>
          </div>
          <div
            className={`d-xxl-none d-block ${classes.mobileInterestCategoriesdiv}`}
          >
            <p className={classes.interestCategoriesTitle}>
              Categories you may interest
            </p>
            <div className="row">
              {categoriesList.map((category, key) => (
                <SingleCategoryItem
                  title={category.title}
                  icon={category.icon}
                  key={key}
                />
              ))}
            </div>
          </div>
        </div>
        <div className={`col-xxl d-xxl-block d-none ${classes.rightContainer}`}>
          <section>
            <p className={classes.profileSearchResultsTitle}>
              Profile search results
            </p>
            {similarProfiles.data.map((profile, key) => (
              <SideBarSimilarProfileItem {...profile} key={key} />
            ))}
          </section>
          <section>
            <p className={classes.interestCategoriesTitle}>
              Categories you may interest
            </p>
            <div className={`row ${classes.listContainer}`}>
              {categoriesList.map((item, key) => (
                <SideBarCategoryItem category={item.title} key={key} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export const searchArticleLoader =
  (sendRequest) =>
  ({ request }) => {
    const searchQuery = new URL(request.url).searchParams.get("q");
    // TODO: need an endpoint to fetch articles according to a search query
    return "ok";
  };
